module.exports = __webpack_public_path__ + "img/aek-athens-logo-icon.ee0d9583.png";